export default __webpack_public_path__ + "c9.png";